/** Cookie consent prompt handlers for Twig-native pages. */

const popup = document.getElementById('js-popup-cookie-block');
if (popup) {
    // Prefer the popup's own data-csrf-token: BodyEndInjector emits it outside
    // the page cache, so it stays valid even when the surrounding head/meta tag
    // is served from a cached homepage render.
    const csrfToken = popup.dataset.csrfToken
        || document.getElementById('js-csrf-token-meta')?.getAttribute('content')
        || '';

    async function postWithCsrf(url, params) {
        try {
            return await fetch(url, {
                method: 'POST',
                headers: {'X-CSRF-Token': csrfToken},
                body: params,
            });
        } catch (e) {
            return null;
        }
    }

    async function acceptCookies(type) {
        const params = new URLSearchParams({type});
        const response = await postWithCsrf('/shopController.php?objective=acceptcookies', params);
        const data = await response?.json().catch(() => null);
        if (data?.error_csrf) {
            alert(data.error_csrf);
            return;
        }
        if (data?.origin) {
            window.location.href = data.origin;
            return;
        }
        window.location.reload();
    }

    async function toggleCookieChoice(redirectUrl) {
        await postWithCsrf(
            '/shopController.php?objective=saveOrigin',
            new URLSearchParams({location: window.location.href}),
        );
        window.location.href = redirectUrl;
    }

    document.getElementById('js-cookie-consent-deny')?.addEventListener('click', () => acceptCookies('deny'));
    document.getElementById('js-cookie-consent-accept')?.addEventListener('click', () => acceptCookies('accept'));
    document.getElementById('js-cookie-consent-adjust')?.addEventListener('click', function() {
        toggleCookieChoice(this.dataset.redirectUrl);
    });
}
